// extracted by mini-css-extract-plugin
export default {"blanket":"Blanket-module--blanket--M5+hF"};